import { v4 as uuidv4 } from 'uuid';

export function Menu(props = {}, childrenComponents = []) {
	return {
		componentName: 'Menu',
		componentId: uuidv4(),
		props: Object.assign(
			{
				orientation: 'horizontal',
			},
			props,
		),
		childrenComponents,
	};
}
